import React from 'react';
import styled from 'styled-components/macro';
import Button from '../Button';
import TermsOfServiceText from './TermsOfServiceText';

const TermsOfServicePopup = ({ onSetAcceptedTOS, close }) => {
  const handleAcceptTOS = e => {
    e.stopPropagation();
    onSetAcceptedTOS(true);
    close();
  };

  const handleClose = e => {
    e.stopPropagation();
    close();
  };

  const preventClickThrough = e => e.stopPropagation();

  return (
    <TermsOfServiceBackground onClick={handleClose}>
      <TermsOfServiceWrapper onClick={preventClickThrough}>
        <TermsOfServiceHeader>Terms of Service</TermsOfServiceHeader>
        <TermsOfServiceBody>
          <TermsOfServiceText />
        </TermsOfServiceBody>
        <TermsOfServiceFooter>
          <Button gray type="button" onClick={handleClose}>
            CANCEL
          </Button>
          <Button type="button" onClick={handleAcceptTOS}>
            ACCEPT
          </Button>
        </TermsOfServiceFooter>
      </TermsOfServiceWrapper>
    </TermsOfServiceBackground>
  );
};

const TermsOfServiceBackground = styled.div`
  #certiself-form & {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #cccccc80;
  }
`;

const TermsOfServiceWrapper = styled.div`
  #certiself-form & {
    width: 100%;
    max-width: 700px;
    height: 80vh;
    margin: auto;
    margin-top: 100px;
    background: #fff;
    display: flex;
    flex-direction: column;
  }
`;

const TermsOfServiceHeader = styled.div`
  #certiself-form & {
    flex-shrink: 0;
    border-bottom: 1px solid #ccc;
    padding: 10px;
    font-size: 20px;
    font-weight: 700;
    text-align: center;
    color: #552a55;
  }
`;

const TermsOfServiceBody = styled.div`
  #certiself-form & {
    flex-grow: 1;
    padding: 5px;
    border-left: 5px solid #fff;
    border-right: 5px solid #fff;
    overflow-y: scroll;
    ::-webkit-scrollbar {
      height: 5px;
      width: 6px;
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: rgba(0, 0, 0, 0.28);
    }
    ::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0.1);
    }
  }
`;

const TermsOfServiceFooter = styled.div`
  #certiself-form & {
    flex-shrink: 0;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #ccc;
  }
`;

export default TermsOfServicePopup;
